export const formatPrice = (value: string | undefined | null | number) =>
  value
    ? parseFloat(value.toString().replace(',', '.')).toFixed(2).replace('.', ',') + ' €'
    : '0,00 €';

export default formatPrice;
